export class CollectionUtils {
  static notEmpty<T>(src: T[]): boolean {
    return src != null && src.length > 0;
  }

  static empty<T>(src: T[]) {
    return src == null  || src.length === 0;
  }
}
